// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="july-23-2021">July 23, 2021</h3>
      <p>The CCE API now presents and accounts for a veteran's PACT status (Patient Aligned Care Team) when calculating eligibility.</p>
      <ul>
      <li>PACT status is only consulted for PrimaryCare requests. A veteran with an active PACT is ineligible for community care for Primary Care appointments.</li>
      <li>The new field 'pactStatus' has been added to the API response when it has been used in the eligibility determination.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/health-apis-community-care-eligibility/pull/131">View code changes(s)</a></p>
      <hr />
      <h3 id="june-10-2020">June 10, 2020</h3>
      <p>The optional query parameter <code>prompt</code> has been added to the authorization flow.</p>
      <ul>
      <li>Supported prompts: login. If specified, the user will be forced to provide credentials regardless of session state. If omitted, an existing active session with the identity provider may not require the user to provide credentials.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-saml-proxy/pull/111">View code changes(s)</a></p>
      <hr />
      <h3 id="july-30-2019">July 30, 2019</h3>
      <p>Launch of the Community Care Eligibility API</p>
    </div>
  );
};

export default MarkdownComponent;
